import { ConnectionSupport } from '@/features/print/connectionSupport'
import { ConnectionType } from '@/features/print/constants'
import { FormInput } from '@/features/settings/components/AddPrinterModal/form/types'

export const getDefaultValues = (preferredConnectionType: ConnectionType): FormInput => {
    return {
        connectionType: ConnectionSupport.isSupportedConnectionType(preferredConnectionType)
            ? preferredConnectionType
            : null,
    }
}
